// https://reactjs.org/docs/hooks-faq.html#how-to-get-the-previous-props-or-state
import type { RefObject } from 'react';
import { useEffect, useRef } from 'react';

// https://gist.github.com/btoo/65e7d4303f49299c785d38f8758525e6
export function usePrevious<T>(value: T): RefObject<T | undefined>['current'] {
  const ref = useRef<T>(undefined);
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}
